<style>

::-webkit-scrollbar {
  width: 10px;
}

::-webkit-scrollbar-thumb {
  background: rgba(191, 188, 188, 0.6);
}

.required_err {
  color: rgba(255, 0, 0);
}

.elevation-1 tr:nth-of-type(even) {
    background-color: rgba(0, 0, 0, .03) !important;
}

.br {
    color: rgba(109, 103, 164);
}

</style>

<template>
<div class="pbr_rules">
    <v-data-table
        :headers="headers"
        :items="items"
        :search="search"
        sort-by="prio"
        class="elevation-1">

    <template v-slot:top>
        <v-toolbar flat>
            <v-toolbar-title><h2 class="br">IPv4 PBR rules</h2></v-toolbar-title>
            <v-spacer></v-spacer>
            <v-dialog v-model="dialog" max-width="600px">
            <div>
                <ipv4_route_table_box v-model="show_ipv4_route_table_form"
                    @canceled="on_ipv4_route_table_form_cancel()"
                    @selected="on_ipv4_route_table_form_select($event)">
                </ipv4_route_table_box>
            </div>

            <template v-slot:activator="{ props }">
                <v-btn @click="new_item(item)"
                    color="primary" dark class="mb-2"
                    v-bind="props">
                    Add PBR rule
                </v-btn>
            </template>

            <ValidationObserver ref="observer" v-slot="{ invalid }"><v-card><v-form>
                <v-card-title>
                    <span class="headline">{{ form_title }}</span>
                </v-card-title>

                <v-card-text>
                    <v-container style="height: 520px; overflow-y: scroll;">
                        <v-row>

                    <v-col cols="12">
                        <div class="br_label">
                            type
                            <treeselect
                                v-bind:readonly="edited_index != -1"
                                v-model="edited_item.type"
                                :multiple="false" 
                                :options="rule_types"
                            />
                        </div>

                        <ValidationProvider rules="required|numeric" v-slot="{ errors }">
                            <v-text-field
                                v-bind:readonly="edited_index != -1"
                                v-model="edited_item.prio"
                                label="Priority"
                            ></v-text-field>
                            <span class="required_err">{{ errors[0] }}</span>
                        </ValidationProvider>

                        <ValidationProvider rules="required|rt_name" v-slot="{ errors }">
                            <v-text-field
                                v-bind:readonly="edited_index != -1"
                                v-model="edited_item.rt"
                                label="Route table">
                                <template v-if="edited_index == -1" #append>
                                    <v-btn @click="open_ipv4_route_table_form()">...</v-btn>
                                </template>                          
                            </v-text-field>
                            <span class="required_err">{{ errors[0] }}</span>
                        </ValidationProvider>

                        <div v-if="edited_item.type === 0">
                            <ValidationProvider rules="required|ipv4_prefix" v-slot="{ errors }">
                                <v-text-field
                                    v-bind:readonly="edited_index != -1"
                                    v-model="edited_item.from_prefix"
                                    label="IPv4 prefix">
                                </v-text-field>
                                <span class="required_err">{{ errors[0] }}</span>
                            </ValidationProvider>
                        </div>

                        <div v-if="edited_item.type === 4">
                            <ValidationProvider rules="required|ipv4_prefix" v-slot="{ errors }">
                                <v-text-field
                                    v-bind:readonly="edited_index != -1"
                                    v-model="edited_item.from_prefix"
                                    label="From prefix">
                                </v-text-field>
                                <span class="required_err">{{ errors[0] }}</span>
                            </ValidationProvider>

                            <ValidationProvider rules="required|ipv4_prefix" v-slot="{ errors }">
                                <v-text-field
                                    v-bind:readonly="edited_index != -1"
                                    v-model="edited_item.to_prefix"
                                    label="To prefix">
                                </v-text-field>
                                <span class="required_err">{{ errors[0] }}</span>
                            </ValidationProvider>
                        </div>

                        <div v-if="edited_item.type === 5">
                            <ValidationProvider rules="required" v-slot="{ errors }">
                                <v-combobox
                                    v-bind:readonly="edited_index != -1"
                                    v-model="edited_item.proto"
                                    label="Protocol"
                                    :items="['tcp', 'udp', 'icmp', 'gre']"
                                ></v-combobox>                    
                                <span class="required_err">{{ errors[0] }}</span>
                            </ValidationProvider>

                            <ValidationProvider rules="required|numeric" v-slot="{ errors }">
                                <v-text-field
                                    v-bind:readonly="edited_index != -1"
                                    v-model="edited_item.src_port"
                                    label="Source port">
                                </v-text-field>
                                <span class="required_err">{{ errors[0] }}</span>
                            </ValidationProvider>
                        </div>

                        <div v-if="edited_item.type === 6">
                            <ValidationProvider rules="required" v-slot="{ errors }">
                                <v-combobox
                                    v-bind:readonly="edited_index != -1"
                                    v-model="edited_item.proto"
                                    label="Protocol"
                                    :items="['tcp', 'udp', 'icmp', 'gre']"
                                ></v-combobox>                    
                                <span class="required_err">{{ errors[0] }}</span>
                            </ValidationProvider>

                            <ValidationProvider rules="required|numeric" v-slot="{ errors }">
                                <v-text-field
                                    v-bind:readonly="edited_index != -1"
                                    v-model="edited_item.dst_port"
                                    label="Destination port">
                                </v-text-field>
                                <span class="required_err">{{ errors[0] }}</span>
                            </ValidationProvider>
                        </div>

                        <div v-if="edited_item.type === 1">
                            <ValidationProvider rules="required" v-slot="{ errors }">
                                <v-text-field
                                    v-bind:readonly="edited_index != -1"
                                    v-model="edited_item.ipset"
                                    label="IP set">
                                </v-text-field>
                                <span class="required_err">{{ errors[0] }}</span>
                            </ValidationProvider>
                        </div>

                        <div v-if="edited_item.type === 2">
                            <ValidationProvider rules="required" v-slot="{ errors }">
                                <v-text-field
                                    v-bind:readonly="edited_index != -1"
                                    v-model="edited_item.l2set"
                                    label="L2 set">
                                </v-text-field>
                                <span class="required_err">{{ errors[0] }}</span>
                            </ValidationProvider>
                        </div>                        
                    </v-col>

                        </v-row>
                    </v-container>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
                    <v-btn v-if="edited_index === -1" color="blue darken-1" 
                        :disabled="invalid" text @click="save">Save</v-btn>
                </v-card-actions>
            </v-form></v-card></ValidationObserver>

            </v-dialog>
        </v-toolbar>   

        <v-toolbar flat>
            <v-text-field v-model="search"
                append-icon="mdi-magnify" label="Search" single-line hide-details
            ></v-text-field>
        </v-toolbar>
    </template>

    <template v-slot:item.actions="{ item }">
        <v-icon small @click="delete_item(item)">
            mdi-delete
        </v-icon>
    </template>

    <template v-slot:no-data>
    </template>

    </v-data-table>
</div>
</template>
  
<script>

import api_client from '../services/api.js';
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import { ValidationProvider, extend } from 'vee-validate';
import { ValidationObserver } from 'vee-validate';
import { required, numeric } from 'vee-validate/dist/rules';
import ipv4_route_table_box from "../components/ipv4_route_table_box.vue";
import "../validation_rules.js"

export default {

name: "pbr_rules",

components: { 
    Treeselect, ValidationProvider, ValidationObserver,
    ipv4_route_table_box
},

data: () => ({
    show_ipv4_route_table_form: false,
    pbr_rules: [],
    search: '',
    dialog: false,
    headers: [
        { text: 'Prio', value: 'prio', align: 'start' },
        { text: 'Condition', value: 'cond' },
        { text: 'Route table', value: 'rt' },
        { text: 'Actions', value: 'actions', sortable: false },
    ],
    items: [],
    edited_index: -1,
    edited_item: {
    },
    default_item: {
        type: -1,
        prio: '',
        cond: '',
        rt: '',
        from_prefix: '',
        to_prefix: '',
        proto: '',
        src_port: '',
        dst_port: '',
        ipset: '',
        l2set: '',
    },
    rule_types: [
          {
            id: -1,
            label: '',
          },

          {
            id: 0,
            label: 'ipv4 prefix',
          },
          {
            id: 4,
            label: 'ipv4 from prefix to prefix',
          },
          {
            id: 1,
            label: 'ipset',
          },
          {
            id: 2,
            label: 'l2set',
          },
          {
            id: 5,
            label: 'source port',
          },
          {
            id: 6,
            label: 'destination port',
          },
        ],    
}),

computed: {
    form_title() {
        return this.edited_index === -1 ? 'Add IPv4 PBR rule' : 'IPv4 PBR rule'
    },
},

watch: {
},

created() {
    this.initialize()
},

methods: {
    on_ipv4_route_table_form_cancel() {
        this.show_ipv4_route_table_form = false;
    },

    on_ipv4_route_table_form_select(rt_name) {
        this.edited_item.rt = rt_name;
        this.show_ipv4_route_table_form = false;
    },

    open_ipv4_route_table_form() {
        this.show_ipv4_route_table_form = true;
    },

    initialize() {
        // Load PBR rules
        return new Promise((resolve, reject) => {
            api_client.run_post_query("/pbr_rules/show")
            .then(response => {
                if (response.data.hasOwnProperty("pbr_rules")) {
                    this.items = response.data.pbr_rules;
                    resolve(response);
                }
            })
            .catch(error => {
                console.log(error);
            });
        });
    },

    new_item() {
        requestAnimationFrame(() => {
            this.$refs.observer.reset();
        });          
        this.edited_index = -1;
        this.edited_item = Object.assign({}, this.default_item);
        this.dialog = true;
    },

    close() {
        this.dialog = false;
        this.$nextTick(() => {
            this.edited_index = -1;
        });
    },

    delete_item(item) {
        this.edited_index = this.items.indexOf(item);
        this.edited_item = Object.assign({}, item);
        this.$confirm("Are you sure you want to delete PBR rule '" + 
            this.edited_item.cond + "', prio " + this.edited_item.prio + " ?")
        .then(() => {
            this.delete_item_confirm()
        });
    },

    delete_item_confirm() {
        api_client.run_post_query('pbr_rules/del', {
            prio: this.edited_item.prio,
        })
        .then(response => {
            if (response.data.hasOwnProperty("err_msg")) {
                this.$fire({title: "Command failed", text: response.data.err_msg, type: "warning"});
                return;
            }
        })
        .catch(error => {
            console.log(error);
            this.$fire({title: "Command failed", text: error, type: "warning"});
        });
        this.items.splice(this.edited_index, 1);
    },

    save_ipv4_prefix_rule()
    {
        let new_rule = {
            prio: this.edited_item.prio,
            rt: this.edited_item.rt,
            prefix: this.edited_item.from_prefix,
        };

        api_client.run_post_query('/pbr_rules/add_from_prefix', new_rule)
        .then(response => {
            if (response.data.hasOwnProperty("err_msg")) {
                this.$fire({title: "Command failed", text: response.data.err_msg, type: "warning"});
            }
            else {
                /* success */
                this.items.push({
                    prio: this.edited_item.prio,
                    rt: this.edited_item.rt,
                    type: this.edited_item.type,
                    cond: "from " + this.edited_item.from_prefix,
                });
                this.close();
            }
        })
        .catch(error => {
            console.log(error);
            this.$fire({title: "Command failed", text: error, type: "warning"});
        });
    },

    save_src_port_rule()
    {
        let new_rule = {
            prio: this.edited_item.prio,
            rt: this.edited_item.rt,
            proto: this.edited_item.proto,
            src_port: this.edited_item.src_port,
        };

        api_client.run_post_query('/pbr_rules/add_src_port', new_rule)
        .then(response => {
            if (response.data.hasOwnProperty("err_msg")) {
                this.$fire({title: "Command failed", text: response.data.err_msg, type: "warning"});
            }
            else {
                /* success */
                this.items.push({
                    prio: this.edited_item.prio,
                    rt: this.edited_item.rt,
                    type: this.edited_item.type,
                    cond: "proto " + this.edited_item.proto + " src port " + this.edited_item.src_port,
                });
                this.close();
            }
        })
        .catch(error => {
            console.log(error);
            this.$fire({title: "Command failed", text: error, type: "warning"});
        });
    },

    save_dst_port_rule()
    {
        let new_rule = {
            prio: this.edited_item.prio,
            rt: this.edited_item.rt,
            proto: this.edited_item.proto,
            dst_port: this.edited_item.dst_port,
        };

        api_client.run_post_query('/pbr_rules/add_dst_port', new_rule)
        .then(response => {
            if (response.data.hasOwnProperty("err_msg")) {
                this.$fire({title: "Command failed", text: response.data.err_msg, type: "warning"});
            }
            else {
                /* success */
                this.items.push({
                    prio: this.edited_item.prio,
                    rt: this.edited_item.rt,
                    type: this.edited_item.type,
                    cond: "proto " + this.edited_item.proto + " dst port " + this.edited_item.dst_port,
                });
                this.close();
            }
        })
        .catch(error => {
            console.log(error);
            this.$fire({title: "Command failed", text: error, type: "warning"});
        });
    },

    save_from_to_prefix_rule()
    {
        let new_rule = {
            prio: this.edited_item.prio,
            rt: this.edited_item.rt,
            from_prefix: this.edited_item.from_prefix,
            to_prefix: this.edited_item.to_prefix,
        };

        api_client.run_post_query('/pbr_rules/add_from_to_prefix', new_rule)
        .then(response => {
            if (response.data.hasOwnProperty("err_msg")) {
                this.$fire({title: "Command failed", text: response.data.err_msg, type: "warning"});
            }
            else {
                /* success */
                this.items.push({
                    prio: this.edited_item.prio,
                    rt: this.edited_item.rt,
                    type: this.edited_item.type,
                    cond: "from " + this.edited_item.from_prefix + " to " + this.edited_item.to_prefix,
                });
                this.close();
            }
        })
        .catch(error => {
            console.log(error);
            this.$fire({title: "Command failed", text: error, type: "warning"});
        });
    },

    save_u32set_rule(set_type, set_name)
    {
        let new_rule = {
            prio: this.edited_item.prio,
            rt: this.edited_item.rt,
            set_name: set_name,
            set_type: set_type,
        };

        api_client.run_post_query('/pbr_rules/add_u32set', new_rule)
        .then(response => {
            if (response.data.hasOwnProperty("err_msg")) {
                this.$fire({title: "Command failed", text: response.data.err_msg, type: "warning"});
            }
            else {
                /* success */
                this.items.push({
                    prio: this.edited_item.prio,
                    rt: this.edited_item.rt,
                    type: this.edited_item.type,
                    cond: set_type + "set " + set_name
                });
                this.close();
            }
        })
        .catch(error => {
            console.log(error);
            this.$fire({title: "Command failed", text: error, type: "warning"});
        });
    },    
    

    save() {
        let type = this.edited_item.type;

        if (type === -1) {
            this.$fire({title: "Notice",
                text: 'rule type should not be empty', type: "warning"});
            return;
        }

        if (type === 0) {
            // ipv4 prefix
            this.save_ipv4_prefix_rule();
        }
        else if (type === 1) {
            // ipset
            this.save_u32set_rule("ip", this.edited_item.ipset);
        }
        else if (type === 2) {
            // l2set
            this.save_u32set_rule("l2", this.edited_item.l2set);
        }
        else if (type === 4) {
            // ipv4 src dst
            this.save_from_to_prefix_rule();
        }
        else if (type === 5) {
            // source port
            this.save_src_port_rule();
        }
        else if (type === 6) {
            // destination port
            this.save_dst_port_rule();
        }
    }, 
}

};
</script>
